/* Module of functions for interacting with the Smart Lab service.
 * All functions return promises that resolve to JSON objects.
 * See the Smart Lab Service API documentation for more information:
 *  https://updates.waterlinkconnect.com/docs/SmartlabServiceAPI_1_0.pdf
 */
import {ScanningErrors} from 'services/errorCodes';

let SMARTLABSERVICE_ENDPOINT = "http://localhost:61547/smartlab"

function _throwIfScannerBusy(response){
    // All SLS API endpoints (except 'about') will return a 'status' result when the scanner is disconnected/busy.
    if (response.Status !== undefined){
      if (response.Status === 0) throw {code: ScanningErrors.TCSMARTLAB_SCANNEROFFLINE};
      throw {code: ScanningErrors.TCSMARTLAB_SCANNERBUSY};
    }
    return response;
}

function _throwServiceOffline(err){
  console.error(err);
  throw {code: ScanningErrors.TCSMARTLAB_SERVICEOFFLINE, error: err};
}

export function SLS_about(){
    return fetch(SMARTLABSERVICE_ENDPOINT + "/about", {cache: "no-store"})
           .catch(_throwServiceOffline)
           .then(response => response.json());
}

export function SLS_status(){
    return fetch(SMARTLABSERVICE_ENDPOINT + "/status", {cache: "no-store"})
           .catch(_throwServiceOffline)
           .then(response => response.json());
}

export function SLS_update(){
    return fetch(SMARTLABSERVICE_ENDPOINT + "/update", {cache: "no-store"})
           .catch(_throwServiceOffline)
           .then(response => response.json());
}

export function SLS_options(){
    return fetch(SMARTLABSERVICE_ENDPOINT + "/options", {cache: "no-store"})
           .catch(_throwServiceOffline)
           .then(response => response.json())
           .then(_throwIfScannerBusy);
}

export function SLS_options_map(){
  /* Returns an object containing 2 mappings:
    ret.sample_map: maps sample names to integer values. eg:

      ret.sample_map: {
        Chlorine: 0,
        Salt: 1,
        Bromine: 2,
        Biguanide: 3
      }

    ret.reagent_map: maps reagent names to integer values. eg:

      ret.reagent_map: {
        26723BIO Series Halogen (CL/BR) Disk II: 11,
        26742BIO Series Halogen (CL/BR) Disk III: 23,
        26725BIO Biguanide Disk II: 12,
        26744BIO Biguanide Disk III: 24,
        Meter Check Disk: 16
      }
  */
  return SLS_options()
    .then((response => {
      let ret = {
        sample_map: {},
        reagent_map: {},
      };

      // Converts array of {"Name":"Chlorine","Value":0,"Tags":["chlorine"]} objects to map[Name] -> Value.
      ret.sample_map = response.SampleTypes.reduce((map, sample) => {
        map[sample.Name] = sample.Value;
        return map;
      }, {});

      // Converts array of {"Name":"26744BIO Biguanide Disk III","Value":24,"Tags":["biguanide"]} objects to map[Name] -> Value.
      ret.reagent_map = response.ReagentTypes.reduce((map, reagent) => {
        map[reagent.Name] = reagent.Value;
        return map;
      }, {});

      return ret;
    }));
}

export function SLS_watertest(sample, reagent){
    return fetch(SMARTLABSERVICE_ENDPOINT + "/watertest?sample=" + sample + "&reagent=" + reagent, {cache: "no-store"})
           .catch(_throwServiceOffline)
           .then(response => response.json())
           .then(_throwIfScannerBusy);
}